import { RootAction, CommunicationHistory, Page, FamilyMember } from "../types";
import { Patient } from "./types";

export interface State {
  data: {
    patient: Patient | null;
    histories: Page<CommunicationHistory>;
    familyMembers: Page<FamilyMember> | null;
  };
  errorMessage: string | null;
  loading: boolean;
  passiveLoading: boolean;
}

const blankState = () => ({
  data: {
    patient: null,
    histories: { count: 1, next: "", previous: "", results: [] },
    familyMembers: null
  },
  errorMessage: null,
  loading: false,
  passiveLoading: false
});

export default (state: State = blankState(), action: RootAction) => {
  switch (action.type) {
    case "patient/setLoading":
      return {
        ...state,
        loading: action.isLoading
      };
    case "patient/getPatient-started":
      return {
        ...state,
        loading: true
      };
    case "patient/getPatient-success":
      return {
        ...state,
        loading: false,
        errorMessage: null,
        data: {
          ...state.data,
          patient: action.patient
        }
      };
    case "patient/getPatient-failure":
      return {
        ...state,
        loading: false,
        errorMessage: action.errorMessage
      };
    case "patient/setPatient":
      return {
        ...state,
        loading: false,
        errorMessage: null,
        data: {
          ...state.data,
          patient: action.patient
        }
      };
    case "patient/deactivatePatient-started":
      return {
        ...state,
        loading: true
      };
    case "patient/deactivatePatient-success":
      return {
        ...state,
        loading: false,
        errorMessage: null
      };
    case "patient/deactivatePatient-failure":
      return {
        ...state,
        loading: false,
        errorMessage: action.errorMessage
      };
    case "patient/getHistory-started":
      return {
        ...state,
        loading: true
      };
    case "patient/getHistory-success":
      return {
        ...state,
        loading: false,
        errorMessage: null,
        data: {
          ...state.data,
          histories: action.histories
        }
      };
    case "patient/getHistory-failure":
      return {
        ...state,
        loading: false,
        errorMessage: action.errorMessage
      };

    case "patient/getFamily-started":
      return {
        ...state,
        loading: true,
        data: {
          ...state.data,
          familyMembers: null
        }
      };
    case "patient/getFamily-success":
      return {
        ...state,
        loading: false,
        errorMessage: null,
        data: {
          ...state.data,
          familyMembers: action.familyMembers
        }
      };
    case "patient/getFamily-failure":
      return {
        ...state,
        loading: false,
        errorMessage: action.errorMessage
      };

    case "patient/addFamilyMember-started":
      return {
        ...state,
        passiveLoading: true
      };
    case "patient/addFamilyMember-success":
      return {
        ...state,
        passiveLoading: false,
        errorMessage: null
      };
    case "patient/addFamilyMember-failure":
      return {
        ...state,
        passiveLoading: false,
        errorMessage: action.errorMessage
      };

    case "patient/deleteFamilyMember-started":
      return {
        ...state,
        passiveLoading: true
      };
    case "patient/deleteFamilyMember-success":
      return {
        ...state,
        passiveLoading: false,
        errorMessage: null
      };
    case "patient/deleteFamilyMember-failure":
      return {
        ...state,
        passiveLoading: false,
        errorMessage: action.errorMessage
      };
    case "patient/getMoreHistory-started":
      return {
        ...state,
        passsiveLoading: true
      };
    case "patient/getMoreHistory-success":
      return {
        ...state,
        passsiveLoading: false,
        errorMessage: null,
        data: {
          ...state.data,
          histories: {
            ...state.data.histories,
            next: action.histories.next,
            previous: action.histories.previous,
            results: state.data.histories.results.concat(action.histories.results)
          }
        }
      };
    case "patient/getMoreHistory-failure":
      return {
        ...state,
        passsiveLoading: false,
        errorMessage: action.errorMessage
      };
    case "patient/addPatient-started":
      return {
        ...state,
        loading: true
      };
    case "patient/addPatient-success":
      return {
        ...state,
        loading: false,
        errorMessage: null
      };
    case "patient/addPatient-failure":
      return {
        ...state,
        loading: false,
        errorMessage: action.errorMessage
      };
    case "patient/editPatient-started":
      return {
        ...state,
        loading: true
      };
    case "patient/editPatient-success":
      return {
        ...state,
        loading: false,
        errorMessage: null
      };
    case "patient/editPatient-failure":
      return {
        ...state,
        loading: false,
        errorMessage: action.errorMessage
      };
  }
  return state;
};
